module.exports = "<div class=\"container-fluid\">\r\n    <div class=\"row\">\r\n        <div class=\"col-md-12\">\r\n            <hr />\r\n            <p class=\"text-center\">{{copyright}}</p>\r\n        </div>\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/footer/footer.html
// module id = ./src/app/components/footer/footer.html
// module chunks = main